"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var SchedulingHistoryController = /** @class */ (function () {
    function SchedulingHistoryController($scope, $window, FlashService, UsersModel, instructor, schedulingHistory) {
        this.$scope = $scope;
        this.$window = $window;
        this.FlashService = FlashService;
        this.UsersModel = UsersModel;
        this.instructor = instructor;
        this.schedulingHistory = schedulingHistory;
        this.formParams = { 'year': 2022 };
        this.year = 2022;
        this.years = [1, 0].map(function (num) {
            return (0, moment_1.default)().subtract(num, "years").toDate().getFullYear();
        });
        this.chartData = this.processChartData();
    }
    SchedulingHistoryController.prototype.processChartData = function () {
        var _this = this;
        var data = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (month) {
            var record = _this.schedulingHistory.find(function (r) { return r.month == month; });
            if (record) {
                return record.minutes_worked / 60;
            }
            return 0;
        });
        return data;
    };
    SchedulingHistoryController.prototype.submit = function () {
        var _this = this;
        this.UsersModel.getInstructorSchedulingHistory(this.instructor.id, {
            months: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
            ],
            year: this.formParams.year, //new Date(Date.now()).getFullYear()
        }).then(function (response) {
            _this.year = _this.formParams.year;
            _this.schedulingHistory = response.scheduling_history;
            _this.processChartData();
        });
    };
    SchedulingHistoryController.prototype.getSchedulingHistory = function () {
        this.UsersModel.getInstructorSchedulingHistory(this.instructor.id, {
            months: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
            ],
            year: 2022, //new Date(Date.now()).getFullYear()
        });
    };
    return SchedulingHistoryController;
}());
SchedulingHistoryController.$inject = ["$scope", "$window", "FlashService", "UsersModel", "instructor", "schedulingHistory"];
exports.default = SchedulingHistoryController;
